import {
    getPercentDiscount,
    SUBSCRIBE_SAVE_SUBS_CHECKBOX_SELECTOR
} from "./subscribe-and-save";

function handleSubscribeSaveDiscount() {
    let subscribe_and_save_discount = getPercentDiscount();
    jQuery(".subscribe-save-settings-percent--js").text(subscribe_and_save_discount + "%");
}

$(document).ready(() => {

    handleSubscribeSaveDiscount();

    // listen for changes to ad campaign types being subscribed to
    $('.subscribe-save-settings__container ' + SUBSCRIBE_SAVE_SUBS_CHECKBOX_SELECTOR).on(
        'change',
        (e) => {
            // may have to recalculate discount and show to user
            handleSubscribeSaveDiscount();
        }
    );
});

